import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { Link } from 'react-router-dom';
import { FolderTree, Flag, FormInput, Settings, User as UserIcon, FlaskConical, Users, Flame, Layers, List, Mail, RefreshCw, Shield, Bell, FileText, Server, ChefHat, Package, Activity } from 'lucide-react';
import { Button } from '../components/ui/button';
import api from '../services/api';
import { toast } from 'sonner';

export const AdminPage = () => {
  const [migrating, setMigrating] = useState(false);

  const runMigration = async () => {
    if (!window.confirm('Spustit migraci dat senzorik? Toto přidá sensory_type="hotovky" ke všem záznamům, které ho nemají.')) {
      return;
    }
    setMigrating(true);
    try {
      const response = await api.post('/sensory/migrate-sensory-types');
      const counts = response.data.migrated_counts || {};
      toast.success(`Migrace dokončena! Aktualizováno: ${counts.sensory_tests || 0} testů, ${counts.sensory_team || 0} členů týmu`);
    } catch (error) {
      toast.error('Chyba při migraci: ' + (error.response?.data?.detail || error.message));
    } finally {
      setMigrating(false);
    }
  };

  const adminSections = [
    {
      title: 'Uživatelé',
      description: 'Správa uživatelů a schvalování registrací',
      icon: UserIcon,
      path: '/admin/users',
      color: 'bg-purple-500',
      testId: 'admin-users'
    },
    {
      title: 'Role a oprávnění',
      description: 'Definice rolí a jejich oprávnění ke stránkám',
      icon: Shield,
      path: '/admin/roles',
      color: 'bg-indigo-500',
      testId: 'admin-roles'
    },
    {
      title: 'Kategorie závad',
      description: 'Správa kategorií pro klasifikaci hlášení',
      icon: FolderTree,
      path: '/admin/categories',
      color: 'bg-blue-500',
      testId: 'admin-categories'
    },
    {
      title: 'Stavy hlášení',
      description: 'Definice stavů a jejich barevné označení',
      icon: Flag,
      path: '/admin/statuses',
      color: 'bg-amber-500',
      testId: 'admin-statuses'
    },
    {
      title: 'Editor formuláře',
      description: 'Visual editor pro úpravu zadávacího formuláře',
      icon: FormInput,
      path: '/admin/form-builder',
      color: 'bg-emerald-500',
      testId: 'admin-form-builder'
    },
    {
      title: 'Senzorika Hotovky - nastavení',
      description: 'Konfigurace polí pro senzorické zkoušky Hotovky',
      icon: FlaskConical,
      path: '/admin/sensory/hotovky',
      color: 'bg-pink-500',
      testId: 'admin-sensory-hotovky'
    },
    {
      title: 'Senzorika Krabičky - nastavení',
      description: 'Konfigurace polí pro senzorické zkoušky Krabičky',
      icon: FlaskConical,
      path: '/admin/sensory/krabicky',
      color: 'bg-fuchsia-500',
      testId: 'admin-sensory-krabicky'
    },
    {
      title: 'Senzorický tým - Hotovky',
      description: 'Správa členů senzorického týmu pro Hotovky',
      icon: Users,
      path: '/admin/sensory-team/hotovky',
      color: 'bg-teal-500',
      testId: 'admin-sensory-team-hotovky'
    },
    {
      title: 'Senzorický tým - Krabičky',
      description: 'Správa členů senzorického týmu pro Krabičky',
      icon: Users,
      path: '/admin/sensory-team/krabicky',
      color: 'bg-emerald-500',
      testId: 'admin-sensory-team-krabicky'
    },
    {
      title: 'Denní report - Hotovky',
      description: 'Emailové notifikace pro Senzorika Hotovky',
      icon: Mail,
      path: '/admin/sensory-daily-report/hotovky',
      color: 'bg-violet-500',
      testId: 'admin-sensory-daily-report-hotovky'
    },
    {
      title: 'Denní report - Krabičky',
      description: 'Emailové notifikace pro Senzorika Krabičky',
      icon: Mail,
      path: '/admin/sensory-daily-report/krabicky',
      color: 'bg-purple-500',
      testId: 'admin-sensory-daily-report-krabicky'
    },
    {
      title: 'Autoklávy',
      description: 'Číselník autoklávy',
      icon: Flame,
      path: '/admin/autoclave-devices',
      color: 'bg-orange-500',
      testId: 'admin-autoclave-devices'
    },
    {
      title: 'Programy autoklávu',
      description: 'Číselník programů autoklávu',
      icon: Layers,
      path: '/admin/autoclave-programs',
      color: 'bg-cyan-500',
      testId: 'admin-autoclave-programs'
    },
    {
      title: 'Záznamy procesu autoklávu',
      description: 'Nastavení polí pro evidenci procesu',
      icon: List,
      path: '/admin/autoclave-process-fields',
      color: 'bg-indigo-500',
      testId: 'admin-autoclave-process-fields'
    },
    {
      title: 'Notifikace úkolů',
      description: 'Nastavení emailových notifikací pro úkoly',
      icon: Bell,
      path: '/admin/task-notifications',
      color: 'bg-blue-500',
      testId: 'admin-task-notifications'
    },
    {
      title: 'Hlavička auditu',
      description: 'Nastavení hlavičky interních auditů',
      icon: FileText,
      path: '/admin/audit-header',
      color: 'bg-emerald-500',
      testId: 'admin-audit-header'
    },
    {
      title: 'Systémové logy',
      description: 'Monitoring API požadavků, chyb a importů',
      icon: Server,
      path: '/admin/system-log',
      color: 'bg-slate-600',
      testId: 'admin-system-log'
    },
    {
      title: 'Server Monitoring',
      description: 'Real-time monitoring paměti, endpointů a chyb',
      icon: Activity,
      path: '/admin/monitoring',
      color: 'bg-blue-600',
      testId: 'admin-monitoring'
    },
    {
      title: 'Nastavení Kuchyně',
      description: 'Položky předávky a filtry pro kuchyni',
      icon: ChefHat,
      path: '/admin/kuchyne',
      color: 'bg-orange-500',
      testId: 'admin-kitchen'
    },
    {
      title: 'Nastavení Balírny',
      description: 'Filtry výrobních záznamů pro balírnu',
      icon: Package,
      path: '/admin/balirna',
      color: 'bg-cyan-500',
      testId: 'admin-balirna'
    }
  ];

  return (
    <Layout>
      <div className="p-8" data-testid="admin-page">
        <div className="mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold text-slate-900 sm:text-4xl mb-2">Administrace</h1>
            <p className="text-lg text-slate-600">Nastavení systému a úprava parametrů</p>
          </div>
          <Button
            onClick={runMigration}
            disabled={migrating}
            variant="outline"
            className="border-red-300 text-red-700 hover:bg-red-50"
          >
            <RefreshCw className={`h-4 w-4 mr-2 ${migrating ? 'animate-spin' : ''}`} />
            {migrating ? 'Migruje...' : 'Migrace dat senzorik'}
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {adminSections.map((section) => {
            const Icon = section.icon;
            return (
              <Link
                key={section.path}
                to={section.path}
                data-testid={section.testId}
                className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm hover:shadow-md transition-all duration-200 hover:-translate-y-1 group"
              >
                <div className={`${section.color} w-12 h-12 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">{section.title}</h3>
                <p className="text-sm text-slate-600">{section.description}</p>
              </Link>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};